<template>
  <section class="app-finance pb-16">
    <integration-steps :current-step="5" />

    <alert-discount />

    <article class="app-finance__wrapper">
      <header class="app-finance__header">
        <h5 class="app-finance__subtitle">
          Marketplace
        </h5>
      </header>

      <div class="app-health-place">
        <p class="app-health-place__call-to-action !px-16">
          O nosso propósito é viabilizar o acesso à saúde de qualidade para milhões
          de brasileiros quem não têm um plano de saúde. Para isso, deixamos médicos
          e pacientes cada vez mais acessíveis uns para os outros. Portanto, ao
          disponibilizar horários na sua agenda com preços mais acessíveis, você se
          conecta a mais pacientes e os pacientes ficam mais conectados com a sua
          saúde. Vamos Juntos?
        </p>

        <p class="app-health-place__text">
          Para receber agendamentos do nosso Marketplace, selecione abaixo a faixa de
          preço por teleconsulta que deseja atender.
        </p>

        <div class="health-place-price">
          <div
            v-for="(option, index) in prices"
            :key="`healht-place-price-option-${index}`"
            class="health-place-price__option"
          >
            <div
              :class="{
                'health-place-price__option-price--selected': JSON.stringify(chosenPrice) === JSON.stringify(option)
              }"
              class="health-place-price__option-price"
              @click="chosenPrice = option"
            >
              {{ option.value }}

              <i
                v-if="JSON.stringify(chosenPrice) === JSON.stringify(option)"
                class="icon icon-check health-place-price__option-icon"
              />
            </div>

            <p class="health-place-price__option-label">
              {{ option.label }}
            </p>
          </div>
        </div>
      </div>

      <p class="app-health-place__text app-health-place__text--disclaimer">
        Agenda automatizada integrada ao sistema com agendamento anonimizado.
        O consumidor localiza conforme especialidade e disponibilidade de agenda,
        nome do médico aparece somente após agendamento. Os valores serão pagos em
        30 dias corridos na sua conta corrente sem desconto ou taxas.
      </p>

      <footer class="app-health-place__footer mobile:justify-center mobile:flex-wrap">
        <div class="app-health-place__footer-col mobile:w-full mobile:text-center mobile:inline ">
          <button
            v-show="isHealthPlaceIntegrationActive"
            class="btn app-integration__revoke-btn mobile:inline"
            @click="revokeHealthPlaceIntegration()"
          >
            Revogar integração com Marketplace
          </button>

          <button
            v-show="!isHealthPlaceIntegrationActive"
            :disabled="isLoading"
            @click="$router.push({ name: 'DoctorAppIntegrationReview' })"
            class="btn btn-green app-integration__submit"
          >
            Integrar depois
          </button>
        </div>

        <div class="app-health-place__footer-col">
          <label class="app-health-place__terms form-checkbox mobile:w-full mobile:whitespace-no-wrap mobile:mt-2">
            <input
              v-model="tos"
              type="checkbox"
            >
            <i class="form-icon" />
            Li e aceito os
            <a @click="showTos($event)">Termos de Uso</a>
          </label>

          <button
            :disabled="!chosenPrice || !tos || isLoading"
            class="btn btn-primary app-integration__submit "
            @click="setHealthPlace"
          >
            Finalizar
          </button>
        </div>
      </footer>
    </article>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import integrationSteps from '@/components/layout/appIntegration/integrationSteps'
import healthPlaceTerms from '@/data/miscData/healthPlaceTerms'
import alertDiscount from '@/components/layout/plans/alertDiscount.vue'

export default {
  name: 'AppIntegrationHealthPlace',

  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  components: {
    integrationSteps,
    alertDiscount
  },

  data () {
    return {
      isLoading: false,
      tos: false,
      chosenPrice: null,
      prices: [
        // {
        //   id: 1,
        //   value: 60,
        //   label: '60% dos consumidores'
        // },
        // {
        //   id: 2,
        //   value: 80,
        //   label: '30% dos consumidores'
        // },
        {
          id: 3,
          value: 100,
          label: ''
          // label: '10% dos consumidores'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      healthPlaceIntegration: 'getHealthPlaceIntegration',
      plan: 'getPlan'
    }),

    isHealthPlaceIntegrationActive () {
      if (
        this.healthPlaceIntegration &&
        'is_active' in this.healthPlaceIntegration
      ) {
        return this.healthPlaceIntegration['is_active']
      }

      return false
    }
  },

  watch: {
    healthPlaceIntegration: {
      deep: true,
      immediate: true,
      handler (healthPlace) {
        if (
          healthPlace &&
          'medical_consultation_price' in healthPlace &&
          this.isHealthPlaceIntegrationActive
        ) {
          this.tos = true
          const { 'medical_consultation_price': value } = healthPlace
          this.chosenPrice = { ...this.prices.find((price) => price.value === value) }
        }
      }
    }
  },

  methods: {
    showTos (event) {
      event.stopPropagation()
      event.preventDefault()

      this.$store.dispatch('setModalAlert', {
        title: 'Termos de uso',
        body: healthPlaceTerms,
        size: 'lg',
        active: true
      })
    },

    setHealthPlace () {
      const url = '/doctor/doctor_health_place'
      const headers = this.$store.getters.getAuthHeader.headers
      const type = this.healthPlaceIntegration ? 'update' : 'create'
      const method = this.healthPlaceIntegration ? 'put' : 'post'
      const data = {
        [type]: {
          medicalConsultationPrice: this.chosenPrice.value,
          isActive: 1
        }
      }

      this.fn_SHOW_PROGRESS()
      this.$http({ url, method, data, headers })
        .then(this.getHealthPlaceIntegration)
        .then(res => this.$store.dispatch('setHealthPlaceIntegration', res))
        .then(() => {
          const callback = () => {
            if (this.plan.isCTA) {
              this.$store.dispatch('setPlan', { isCTA: false })
              this.$router.push({ name: 'DoctorPlansCheckout' })
            } else {
              this.$router.push({ name: 'DoctorAppIntegrationReview' })
            }
          }

          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Integração com Marketplace concluída com sucesso.',
            size: 'md',
            active: true,
            callback
          })
        })
        .catch(err => this.handleError(err))
        .finally(() => {
          this.isSaving = false
          this.fn_HIDE_PROGRESS()
        })
    },

    getHealthPlaceIntegration () {
      return new Promise((resolve, reject) => {
        this.$http
          .get('/doctor/doctor_health_place', this.$store.getters.getAuthHeader)
          .then(res => resolve(res.data))
          .catch((err) => reject(err))
      })
    },

    revokeHealthPlaceIntegration () {
      this.$store.dispatch('setModalConfirm', {
        title: 'Atenção',
        body: `Tem certeza que deseja desativar a integração
          do seu perfil com a plataforma Marketplace?`,
        confirmText: 'Revogar integração',
        cancelText: 'Voltar',
        beforeClose: (v) => {
          this.$store.dispatch('setModalConfirm')

          if (v) {
            const url = `/doctor/doctor_health_place`
            const data = {
              'update': {
                medicalConsultationPrice: this.chosenPrice.value,
                isActive: 0
              }
            }

            this.fn_SHOW_PROGRESS()
            this.$http
              .put(url, data, this.$store.getters.getAuthHeader)
              .then(this.getHealthPlaceIntegration)
              .then(res => this.$store.dispatch('setHealthPlaceIntegration', res))
              .then(() => {
                this.$store.dispatch('setModalAlert', {
                  title: 'Sucesso',
                  body: 'A integração com o Marketplace foi desativada com sucesso',
                  size: 'md',
                  active: true,
                  callback: () => this.$router.push({ name: 'DoctorAgenda' })
                })
              })
              .catch(err => this.fn_HANDLE_ERROR(err))
              .finally(this.fn_HIDE_PROGRESS())
          }
        },
        size: 'md1',
        active: true
      })
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    },

    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    }
  }
}
</script>
